<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar rounded="" color="secondary" dense elevation="1">            
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & Inventory'}, {text: 'Warehouse'}, {text: 'Edit Warehouse'}]" large></v-breadcrumbs>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Edit Warehouse
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete" v-if="this.hasPermission(this.perm.warehouse.delete)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" v-if="this.hasPermission(this.perm.warehouse.index)"/>
                            <PIconBtn icon="mdi-cancel" tooltip="Cancel" @click="handleCancel"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <v-divider></v-divider>
                    <WarehouseForm
                        v-if="!warehouseLoading"
                        ref="form" 
                        v-model="data" 
                        class="pa-3"
                    />
                    <div v-else class="pa-3"> 
                        <v-col cols="12" md="4" >
                            <v-skeleton-loader
                                type="text"
                            >
                            </v-skeleton-loader>
                        </v-col>
                        <v-col cols="12" md="4" >
                            <v-skeleton-loader
                                type="text"
                            >
                            </v-skeleton-loader>
                        </v-col>
                        <v-col cols="12" md="4" >
                            <v-skeleton-loader
                                type="text"
                            >
                            </v-skeleton-loader>
                        </v-col>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import permissions from './../../data/permissions'
import PAlert from './../../components/common/PAlert'
import PIconBtn from './../../components/common/PIconBtn'
import WarehouseForm from './../../components/warehouse/WarehouseForm';
import { mapActions, mapGetters } from 'vuex';
export default {
    name: "WarehouseEditView",
    components: {
        WarehouseForm,
        PIconBtn,
        PAlert
    },
    data() {
        return {
            id: null,
            data: null,
            warehouseLoading: false,
            alert: {
                title: "Alert",
                content: "Are you sure you want to save",
                value: false,
                callback: null
            },
            loading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        })
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            findByID: "warehouse/warehouse/findByID",
            update: "warehouse/warehouse/update",
            remove: "warehouse/warehouse/remove"
        }),
        getWarehouse() {
            this.warehouseLoading = true
            this.findByID(this.id).then(response => {
                this.data = response.data 
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.warehouseLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save(){
            this.loading = true 
            this.update(this.data).then(response => {
                this.$router.push({ name: "WarehouseDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Warehouse Updated", color: "success"})
            }).catch( error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = true
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Delete?", callback: this.removeWarehouse};
        },
        removeWarehouse() {
            this.loading = true
            this.remove(this.data).then(() => {
                this.$router.push({ name: "WarehouseList" })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "WarehouseList"})
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Discard Changes?", callback: this.cancel};
        },
        cancel() {
            this.$router.back()
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getWarehouse()
    },
    beforRouteUpdate(to, from, next) {
        this.id = to.params.id;
        this.getWarehouse();
        next()
    }
}
</script>

<style>

</style>